import { Input } from '@chakra-ui/react'
import { FC, useState } from 'react'

import useParametrizationIncrementSupplier from '@hook/parametrization/use-incremet'

import LayoutToolsButton from '../../Components/Button'

const ActionParametrizationIncrementSupplyUpload: FC = () => {
  const [isLoading, setLoading] = useState(false)

  const { postUpload } = useParametrizationIncrementSupplier()

  const handleClick = () => {
    const inputValue =
      document.querySelector<HTMLInputElement>('#supply-upload')

    inputValue.value = ''
    inputValue!.click()
  }

  return (
    <>
      <LayoutToolsButton
        label="Upload de arquivo"
        isLoading={isLoading}
        loadingText="Fazendo upload"
        onClick={handleClick}
      />
      <Input
        id="supply-upload"
        d="none"
        type="file"
        accept="text/csv"
        onChange={event => {
          postUpload(event)
          setLoading(true)

          setTimeout(() => {
            setLoading(false)
          }, 2000)
        }}
      />
    </>
  )
}

export default ActionParametrizationIncrementSupplyUpload
